import { UserActionCollection, getUserActionTypeName } from '@/typings/api/User'
import { dateFormatter } from '@/helpers/dateFormatter'
import { USERS_ROUTES } from '@/views/Users/utils'


export const TABLE_ACTIONS = Object.freeze([
])

export const TABLE_HEADERS = Object.freeze([
  {
    text: 'Тип действия',
    value: 'action_type',
    sortable: false,
    width: 180,
    field: (value: UserActionCollection['action_type']) => (
      getUserActionTypeName(value).label
    ),
  },
  {
    text: 'ID объекта, к которому применили действие',
    value: 'object_id',
    sortable: false,
    width: 180,
  },
  {
    text: 'Название модели объекта',
    value: 'object_model_name',
    sortable: false,
  },
  {
    text: 'Описание',
    value: 'description',
    sortable: false,
  },
  {
    text: 'SUAS от пользователя',
    value: 'suas_user_username',
    sortable: false,
    getRoute: (data: UserActionCollection) => ({
      name: USERS_ROUTES.VIEW,
      params: { id: data.suas_user_id },
    }),
  },
  {
    text: 'Дата создания',
    value: 'created_at',
    sortable: false,
    width: 140,
    field: (value: string) => value && dateFormatter(value),
  },
])
